function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHex = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 54 62.4"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m0 46.8 27 15.6 27-15.6V15.6L27 0 0 15.6z",
  style: {
    fill: "#4545ff"
  }
}));
export { SvgHex as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1NCA2Mi40IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCA1NCA2Mi40IiB4bWw6c3BhY2U9InByZXNlcnZlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgogIC5zdDB7ZmlsbDojNDU0NUZGO30KPC9zdHlsZT4KCTxwb2x5Z29uIGNsYXNzPSJzdDAiIHBvaW50cz0iMCA0Ni44IDI3IDYyLjQgNTQgNDYuOCA1NCAxNS42IDI3IDAgMCAxNS42Ii8+Cjwvc3ZnPgo=";